import { singlePayout } from '@api/payout';
import { formatErrorMessage } from '@basqet-dashboard/common/utils';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import { PayoutErrorView, PayoutLoadingView } from '../../process-payout';
import { PayoutSuccessView } from './success-view';

const ProcessPayout = ({ setCurrentStage, transactionInfo }) => {
  const [payoutState, setPayoutState] = useState('LOADING');
  const [message, setMessage] = useState(`Your transfer is in progress.`);

  useEffect(async () => {
    const { currency_id, network, amount, address, otp } = transactionInfo;
    const transaction = { currency_id, network, amount, address, otp };

    try {
      await singlePayout(transaction);
      setPayoutState('SUCCESS');
    } catch (error) {
      formatErrorMessage(error);
      if (error.response.data.message.includes('code')) {
        // send them back to the 2FA page
        await delete transactionInfo.otp;
        setCurrentStage('TWOFA_AUTHENTICATION');
      } else {
        setPayoutState('ERROR');
      }
    } finally {
      setMessage('');
    }
  }, []);

  const PayoutView = payoutStates[payoutState];

  return <PayoutView transactionDetails={transactionInfo} message={message} />;
};
const payoutStates = {
  LOADING: PayoutLoadingView,
  ERROR: PayoutErrorView,
  SUCCESS: PayoutSuccessView
};

ProcessPayout.propTypes = {
  transactionInfo: PropTypes.object,
  setCurrentStage: PropTypes.func
};

export { ProcessPayout };
